// Templates tab — reuses the existing Automation Templates page
// (templates used by chatbot replies, stored in `automation_templates` collection).
import React from 'react';
import AutomationTemplates from '../../whatsapp/AutomationTemplates';

const TemplatesTab = () => <AutomationTemplates />;

export default TemplatesTab;
